export class CreatePlanDto{
  name: string;
}
